import { pipe } from 'fp-ts/lib/function';
import { failure, parse, string, success } from 'io-ts/lib/Decoder';

const reUrl = /^(https?):\/\/[^\s/$.?#].[^\s]*$/i;
export const Url = pipe(
	string,
	parse((s) =>
		s.trim().length > 0 &&
		// check if s is a valid url
		reUrl.test(s)
			? success(s)
			: failure(s, 'valid url')
	)
);
